module.exports = __webpack_public_path__ + "0dc2ca3ec9f89e3ba6a113f5b2fb4d7d.pdf";